<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self" @reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增</vxe-button>
									<vxe-button status="primary" class="button-sty" icon="el-icon-upload2" @click="$excelExport({ title: '导出', targetRef: 'table-m1' })">
										导出
									</vxe-button>
									<!-- <vxe-button status="primary" class="button-sty" icon="el-icon-download" @click="importExcel">导入</vxe-button> -->
								</div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="服务类型:" field="faultDescription">
									<template v-slot>
										<el-input v-model="formData.faultDescription" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="故障原因:" field="faultReason">
									<template v-slot>
										<el-input v-model="formData.faultReason" size="small" clearable />
									</template>
								</vxe-form-item>
								<vxe-form-item title="语言:" field="languageId">
									<template v-slot>
										<el-select v-model="formData.languageId" clearable>
											<el-option
												v-for="languageDTO in languageDTOs"
												:key="'languageDTO' + languageDTO.id"
												:value="languageDTO.id"
												:label="languageDTO.language"
											></el-option>
										</el-select>
									</template>
								</vxe-form-item>
								<vxe-form-item title="是否启用:" field="stat">
									<template v-slot>
										<el-select v-model="formData.stat" clearable>
											<el-option :value="1" label="启用"></el-option>
											<el-option :value="9" label="禁用"></el-option>
										</el-select>
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
export default {
	name: 'faultcodelist',
	components: { editView },
	data() {
		return {
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			formData: {},
			showProductCategoryDialog: false,
			languageDTOs: []
		};
	},
	mounted() {
		// this.initLauguage();
		this.initTableList();
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		initTableList() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/admin/user/page',
				param: () => {
					return this.formData;
				},
				columns: [
					{ type: 'checkbox', width: 48, resizable: false, fixed: 'left' },
					{
						title: '商品分类名称',
						field: 'itemCatName',
						width: 150,
						fixed: 'left'
					},
					{
						title: '语言',
						field: 'languageName',
						width: 150
					},
					{
						title: '故障描述',
						field: 'faultDescription',
						width: 150
					},
					{
						title: '故障原因',
						field: 'faultReason',
						width: 150
					},
					{
						title: '触发条件',
						field: 'triggerCondition',
						width: 150
					},
					{
						title: '解决方案',
						field: 'solution',
						width: 150
					},
					{
						title: '视频链接',
						field: 'vodioUrl',
						width: 150
					},
					{
						field: 'stat',
						title: '是否启用',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.stat == 1) {
									return [
										<div class="txt-status">
											<span>启用</span>
										</div>
									];
								} else if (row.stat == 9) {
									return [
										<div class="txt-status disable">
											<span>禁用</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '备注',
						field: 'remark',
						width: 150
					},
					{
						field: 'createDate',
						title: '创建时间',
						width: 150
					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				this.vxeOption = opts;
			});
		},
		initLauguage() {
			this.$http({
				url: '/lauguage/lists',
				method: `post`,
				data: {},
				isLoading: true,
				modalStrictly: true,
				success: res => {
					this.languageDTOs = res.objx || [];
				}
			});
		},
		confirmCategory(rows) {
			if (rows.length > 0) {
				let row = rows[0];
				this.formData.itemCatId = row.id;
				this.formData.itemCatName = row.categoryName;
			}
		}
	}
};
</script>
